<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <span ref="tipoCliente" style="font-size:35px;font-weight:bold;">{{ tipoDeCliente }}</span>
      </v-col>
      <v-col cols="12">
        <!-- esto solo es para el remitente -->
        <div class="d-flex mtll">
          <v-text-field
            @focus="$event.target.select()"
            dense
            :error-messages="nombreC_Errors"
            @input="
              $v.cliente.nombre.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.nombre.$touch()"
            :disabled="deshabilitarCampos"
            v-model.trim="cliente.nombre"
            outlined
            class="mr-2"
            :label="retornaEtiquetaInputNombre"
          ></v-text-field>
          <v-btn
            :disabled="deshabilitarBotonAgregarUsuario"
            @click="insertaNuevoCliente()"
            color="purple"
            style="height:40px;"
            class="mr-2 white--text"
            ><v-icon large right>mdi-account-multiple-plus</v-icon></v-btn
          >
          <v-btn @click="abreModalClientes()" style="height:40px;" color="primary"
            ><v-icon large dark right>mdi-magnify</v-icon></v-btn
          >
        </div>
        <!-- lo de abajo es para el titular -->
        <!-- lo de abajo es para el titular -->
        <!-- lo de abajo es para el titular -->
        <div class="d-flex mtll" v-if="tipoDeCliente == 'Remitente'">
          <v-text-field
            @focus="$event.target.select()"
            dense
            :error-messages="titularDocumentoC_Errors"
            @input="
              $v.nombreDelTitularDelEnvio.$touch();
              actualizaCliente();
            "
            @blur="$v.nombreDelTitularDelEnvio.$touch()"
            v-model.trim="nombreDelTitularDelEnvio"
            outlined
            class="mr-2"
            label="Nombre del remitente"
          ></v-text-field>
          <!-- <v-btn
            :disabled="deshabilitarBotonAgregarUsuario"
            @click="insertaNuevoCliente()"
            color="purple"
            style="height:40px;"
            class="mr-2 white--text"
            ><v-icon large right>mdi-account-multiple-plus</v-icon></v-btn
          > -->
          <v-btn
            @click="abreModalClientesParaInsertarTitular()"
            style="height:40px;"
            color="primary"
            ><v-icon large dark right>mdi-magnify</v-icon></v-btn
          >
        </div>
        <div class="mtll d-flex">
          <v-text-field
            class="mr-2"
            @focus="$event.target.select()"
            dense
            v-model.trim="cliente.razonSocial"
            outlined
            :error-messages="razonSocial_Errors"
            @input="
              $v.cliente.razonSocial.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.razonSocial.$touch()"
            label="Razón social"
            >das</v-text-field
          >
          <v-text-field
            @focus="$event.target.select()"
            dense
            v-model.trim="cliente.rfc"
            outlined
            :disabled="deshabilitarCampos"
            @input="
              $v.cliente.razonSocial.$touch();
              actualizaCliente();
            "
            label="RFC/TAX ID"
          ></v-text-field>
        </div>

        <div v-if="this.tipoDeCliente == 'Remitente'" class="d-flex mtll">
          <v-text-field
            dense
            @focus="$event.target.select()"
            autocomplete="new-text"
            :disabled="deshabilitarCamposOcurre"
            :error-messages="direccioneC_Errors"
            @input="
              $v.cliente.direccion.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.direccion.$touch()"
            v-model.trim="cliente.direccion"
            outlined
            style="width:100%;"
            label="Dirección"
            ><div style="width:150px;" slot="append" class="d-flex mtll"></div
          ></v-text-field>
          <div style="margin-left:-150px;margin-top:10px;" class="d-flex mtll">
            <span style="margin-top:0px;" class="mr-3">OCURRE</span>
            <v-switch
              :disabled="false"
              @click="actualizaCliente()"
              @input="actualizaCliente()"
              style="margin-top:-5px;"
              v-model.trim="cliente.envioOcurre"
              class="mr-2"
              flat
              inset
            ></v-switch>
          </div>
        </div>
        <div v-else class="d-flex mtll">
          <v-text-field
            @focus="$event.target.select()"
            dense
            :disabled="deshabilitarCamposOcurre"
            :error-messages="direccioneC_Errors"
            @input="
              $v.cliente.direccion.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.direccion.$touch()"
            v-model.trim="cliente.direccion"
            outlined
            autocomplete="new-text"
            label="Dirección"
            ><div slot="append" class="d-flex mtll">
              <span style="margin-top:0px;" class="mr-3">ENVIO A OCURRE</span>
              <v-switch
                :disabled="false"
                @click="actualizaCliente()"
                @input="actualizaCliente()"
                style="margin-top:-5px;"
                v-model="cliente.envioOcurre"
                class="mr-2"
                flat
                inset
              ></v-switch></div
          ></v-text-field>
        </div>
        <div class="d-flex mtll">
          <v-text-field
            @focus="$event.target.select()"
            dense
            autocomplete="new-text"
            :disabled="deshabilitarCamposOcurre"
            :error-messages="cp_Errors"
            @input="
              $v.cliente.cp.$touch();
              actualizaClienteCodigoPostal();
            "
            @blur="$v.cliente.cp.$touch()"
            v-model.trim="cliente.cp"
            outlined
            class="mr-2"
            label="CP"
          ></v-text-field>
          <v-text-field
            @focus="$event.target.select()"
            dense
            :error-messages="colonia_Errors"
            @input="
              $v.cliente.colonia.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.colonia.$touch()"
            autocomplete="new-text"
            v-if="!mostrarComboxColonias"
            v-model.trim="cliente.colonia"
            class="mr-2"
            :disabled="deshabilitarCamposOcurre"
            outlined
            label="Segunda línea dirección/Colonia"
          ></v-text-field>
          <v-combobox
            dense
            class="mr-2"
            @input="actualizaCliente()"
            v-if="mostrarComboxColonias"
            v-model.trim="cliente.colonia"
            :items="codigosPostalesEncontrados"
            label="Segunda línea dirección/Colonia"
            outlined
          ></v-combobox>
          <v-combobox
            dense
            :items="listaPaises"
            autocomplete="new-text"
            v-if="tipoDeCliente === 'Destinatario'"
            :error-messages="pais_Errors"
            item-text="NOMBRE"
            item-value="NOMBRE"
            @input="
              $v.cliente.pais.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.pais.$touch()"
            v-model.trim="cliente.pais"
            outlined
            label="Pais"
          ></v-combobox>
          <!-- <v-text-field
            dense
            autocomplete="new"
            v-if="tipoDeCliente === 'Destinatario'"
            :error-messages="pais_Errors"
            @input="
              $v.cliente.pais.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.pais.$touch()"
            v-model.trim="cliente.pais"
            outlined
            label="Pais"
          ></v-text-field> -->
        </div>
        <div class="d-flex mtll">
          <v-text-field
            @focus="$event.target.select()"
            dense
            class="mr-2"
            autocomplete="new-text"
            :disabled="deshabilitarCamposOcurre"
            :error-messages="ciudad_Errors"
            @input="
              $v.cliente.ciudad.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.ciudad.$touch()"
            v-model.trim="cliente.ciudad"
            outlined
            label="Ciudad"
          ></v-text-field>
          <v-combobox
            dense
            :items="estadosARetornar"
            autocomplete="new-text"
            :disabled="deshabilitarCamposOcurre"
            :error-messages="estado_Errors"
            @input="
              $v.cliente.estado.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.estado.$touch()"
            v-model.trim="cliente.estado"
            :class="{ 'mr-2': tipoDeCliente === 'Destinatario' }"
            outlined
            label="Estado"
          ></v-combobox>
        </div>

        <div class="d-flex mtll">
          <v-text-field
            @focus="$event.target.select()"
            dense
            autocomplete="new-text"
            :disabled="deshabilitarCampos"
            :error-messages="telefono_Errors"
            @input="
              $v.cliente.telefono.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.telefono.$touch()"
            v-model.trim="cliente.telefono"
            class="mr-2"
            outlined
            label="Telefono"
          ></v-text-field>
          <v-text-field
            @focus="$event.target.select()"
            dense
            class="mr-2"
            autocomplete="new-text"
            :disabled="deshabilitarCampos"
            :error-messages="email_Errors"
            @input="
              $v.cliente.email.$touch();
              actualizaCliente();
            "
            @blur="$v.cliente.cp.$touch()"
            v-model.trim="cliente.email"
            outlined
            label="Email"
          ></v-text-field>
          <v-select
            v-if="tipoDeCliente == 'Remitente'"
            outlined
            dense
            @input="actualizaTarifaRemitente()"
            v-model="cliente.idTarifaRemitente"
            item-text="texto"
            item-value="id"
            class="mr-2"
            label="Tarifa"
            :items="[
              { id: 1, texto: 'Publico en General' },
              { id: 2, texto: 'Mayorista' },
              { id: 3, texto: 'Frecuente' },
              { id: 4, texto: 'Esporadico' }
            ]"
          ></v-select>
          <!-- <v-btn v-if="tipoDeCliente == 'Remitente'" @click="abreModalCajas()" dark style="height:40px;" class="mr-2" color="blue"
            >cajas
            <v-icon medium class="mr-2"> mdi-package </v-icon>
          </v-btn> -->
          <v-btn
            :id="asignaNombreBotonLimpiar"
            :ref="asignaNombreBotonLimpiar"
            @click="limpiarDatosCliente()"
            color="blue"
            dark
            style="height:40px;"
          >
            LIMPIAR
          </v-btn>
        </div>
      </v-col>
      <v-btn
        dense
        v-if="
          tipoDeCliente == 'Destinatario' &&
            cliente.pais != 'México' &&
            cliente.pais != null &&
            cliente.pais != ''
        "
        block
        color="primary"
        @click="buscarDireccionEnGoogleMaps()"
        >buscar direccion en google maps</v-btn
      >
    </v-row>
    <v-snackbar
      v-model="snackbarInfo"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      :color="colorModalInfo"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarInfo }}
      </span></v-snackbar
    >
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
const nombreCRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑ]+([ ][a-zA-ZÁÉÍÓÚáéíóúñÑ]+){1,})$/;
const direccionDireccionRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 äÄöÖüÜ!@#$%^&*/|().,´"'_+]){1,35})$/;
const direccionColoniaRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ0-9 !@#$%^&*/|().,´"'_+]){0,50})$/;
const direccionMunicipioRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ0-9 ().,´"'_]){1,35})$/;
const direccionEstadoRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ ]){1,35})$/;
const direccionCodigoPostalRegex = /^([0-9a-zA-ZÁÉÍÓÚáéíóúÑñäÄöÖüÜ -]{2,10})$/;
const razonSRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){0,35})$/;
const telefonoRegex = /^(([+]{1}[0-9]{1,4})?([0-9]{10}))?$/;
const emailRegex = /^(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+)?$/;
const direccionPaisRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑäÄöÖüÜ ]{0,35})$/;

export default {
  props: {
    tipoDeCliente: {
      type: String
    },
    datosRemitente: {
      type: Object
    },
    datosDestinatario: {
      type: Object
    },
    datoQueLimpiaDatosAlCambiar: {
      type: Number
    },
    datosTitularCuenta: {
      type: String,
      default: ""
    }
  },
  validations: {
    nombreDelTitularDelEnvio: {
      maxLength: maxLength(35),
      nombreCValida(Nombre_Completo) {
        if (this.nombreDelTitularDelEnvio.length == 0 || this.nombreDelTitularDelEnvio == null) {
          return true;
        } else {
          return nombreCRegex.test(Nombre_Completo);
        }
      }
    },
    cliente: {
      email: {
        emailValida(email) {
          if (this.cliente.email.length == 0 || this.cliente.email == null) {
            return true;
          } else {
            return emailRegex.test(email);
          }
        }
      },
      nombre: {
        maxLength: maxLength(35),
        required,
        nombreCValida(Nombre_Completo) {
          return nombreCRegex.test(Nombre_Completo);
        }
      },
      direccion: {
        required,
        direccionValida(direccion) {
          return direccionDireccionRegex.test(direccion);
        }
      },
      colonia: {
        required: requiredIf(function(form) {
          return this.quitarAcentos(this.cliente.pais + "").toLowerCase() == "mexico";
        }),
        coloniaValida(colonia) {
          return direccionColoniaRegex.test(colonia);
        }
      },
      razonSocial: {
        razonSValida(razonSocial) {
          return razonSRegex.test(razonSocial);
        }
      },
      ciudad: {
        required,
        municipioValida(ciudad) {
          return direccionMunicipioRegex.test(ciudad);
        }
      },
      estado: {
        required,
        estadoValida(estado) {
          return direccionEstadoRegex.test(estado);
        }
      },
      cp: {
        required,
        codigoPostalValida(cp) {
          return direccionCodigoPostalRegex.test(cp);
        }
      },
      pais: {
        required: requiredIf(function(form) {
          return this.tipoDeCliente == "Destinatario";
        }),
        paisValida(pais) {
          if (this.tipoDeCliente == "Destinatario") {
            return direccionPaisRegex.test(pais);
          } else {
            return true;
          }
        }
      },
      telefono: {
        required: requiredIf(function(form) {
          return this.tipoDeCliente != "Destinatario";
        }),
        telefonoValida(telefono) {
          if (this.cliente.telefono.length == 0 || this.cliente.telefono == null) {
            return true;
          } else {
            return telefonoRegex.test(telefono);
          }
        }
      }
    }
  },
  data: () => ({
    colorModalInfo: "blue darken-1",
    snackbarInfo: false,
    mensajeSnackbarInfo: "",
    deshabilitarCamposOcurre: false,
    deshabilitarCampos: false,
    copiaRemitenteX: {},
    nombreDelTitularDelEnvio: "",
    cliente: {
      envioOcurre: false,
      alias: "",
      id: "",
      nombre: "",
      razonSocial: "",
      direccion: "",
      colonia: "",
      ciudad: "",
      estado: "",
      cp: "",
      pais: null,
      telefono: "",
      email: "",
      idTarifaRemitente: 1,
      tarifaClienteEspecifica: "",
      tarifaClientePublicoGeneral: "",
      rfc: ""
    },
    codigosPostalesEncontrados: [],
    mostrarComboxColonias: false
  }),
  computed: {
    ...mapState("sepomex", {
      codigosList: state => state.datosConCodigoPostal
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo,
      sucursalInfo: state => state.sesion.sucursalData,
      listaPaises: state => state.sepomex.listaPaises
    }),
    estadosARetornar() {
      if (this.cliente.pais == "Estados Unidos") {
        return [
          "AL Alabama",
          "AK Alaska",
          "AR Arkansas",
          "AS American Samoa",
          "AZ Arizona",
          "CA California",
          "CO Colorado",
          "CT Connecticut",
          "DC District of Columbia",
          "DE Delaware",
          "FL Florida",
          "GA Georgia",
          "HI Hawaii",
          "IA Iowa",
          "ID Idaho",
          "IL Illinois",
          "IN Indiana",
          "KS Kansas",
          "KY Kentucky",
          "LA Louisiana",
          "MA Massachusetts",
          "MD Maryland",
          "ME Maine",
          "MI Michigan",
          "MN Minnesota",
          "MO Missouri",
          "MP Northern Mariana Islands",
          "MS Mississippi",
          "MT Montana",
          "NC North Carolina",
          "ND North Dakota",
          "NE Nebraska",
          "NH New Hampshire",
          "NJ New Jersey",
          "NM New Mexico",
          "NV Nevada",
          "NY New York",
          "OH Ohio",
          "OK Oklahoma",
          "OR Oregon",
          "PA Pennsylvania",
          "PR Puerto Rico",
          "RI Rhode Island",
          "SC South Carolina",
          "SD South Dakota",
          "TN Tennessee",
          "TX Texas",
          "UT Utah",
          "VA Virginia",
          "VT Vermont",
          "WA Washington",
          "WI Wisconsin",
          "WV West Virginia",
          "WY Wyoming"
        ];
      } else if (this.cliente.pais == "Canadá") {
        return [
          "AB Alberta",
          "BC British Columbia",
          "MB Manitoba",
          "NB New Brunswick",
          "NF Newfoundland and Labrador",
          "NS Nova Scotia",
          "NT Northwest Territories",
          "NU Nunavut",
          "ON Ontario",
          "PE Prince Edward Island",
          "PQ Quebec",
          "SK Saskatchewan",
          "YT Yukon Territory"
        ];
      } else if (this.cliente.pais == "México") {
        return [
          "Aguascalientes",
          "Baja California",
          "Baja California Sur",
          "Campeche",
          "Coahuila de Zaragoza",
          "Colima",
          "Chiapas",
          "Chihuahua",
          "Ciudad de México",
          "Durango",
          "Guanajuato",
          "Guerrero",
          "Hidalgo",
          "Jalisco",
          "México",
          "Michoacán de Ocampo",
          "Morelos",
          "Nayarit",
          "Nuevo León",
          "Oaxaca",
          "Puebla",
          "Querétaro",
          "Quintana Roo",
          "San Luis Potosí",
          "Sinaloa",
          "Sonora",
          "Tabasco",
          "Tamaulipas",
          "Tlaxcala",
          "Veracruz de Ignacio de la Llave",
          "Yucatán",
          "Zacatecas"
        ];
      }
    },
    retornaEtiquetaInputNombre() {
      if (this.tipoDeCliente === "Destinatario") {
        return "Nombre del destinatario";
      } else {
        return "Nombre del cliente";
      }
    },
    deshabilitarBotonAgregarUsuario() {
      if (this.cliente.id) {
        return true;
      } else {
        return false;
      }
    },
    asignaNombreBotonLimpiar() {
      if (this.tipoDeCliente == "Remitente") {
        return "btnRemitente";
      } else {
        return "btnDestinatario";
      }
    },
    titularDocumentoC_Errors() {
      const errors = [];
      if (!this.$v.nombreDelTitularDelEnvio.$dirty) return errors;
      !this.$v.nombreDelTitularDelEnvio.maxLength && errors.push("");

      !this.$v.nombreDelTitularDelEnvio.nombreCValida && errors.push("");
      return errors;
    },
    nombreC_Errors() {
      const errors = [];
      if (!this.$v.cliente.nombre.$dirty) return errors;
      !this.$v.cliente.nombre.maxLength && errors.push("");
      !this.$v.cliente.nombre.required && errors.push("");
      !this.$v.cliente.nombre.nombreCValida && errors.push("");
      return errors;
    },
    direccioneC_Errors() {
      const errors = [];
      if (!this.$v.cliente.direccion.$dirty) return errors;
      !this.$v.cliente.direccion.required && errors.push("");
      !this.$v.cliente.direccion.direccionValida && errors.push("");
      return errors;
    },
    colonia_Errors() {
      const errors = [];
      if (!this.$v.cliente.colonia.$dirty) return errors;
      !this.$v.cliente.colonia.required && errors.push("");
      !this.$v.cliente.colonia.coloniaValida && errors.push("");
      return errors;
    },
    ciudad_Errors() {
      const errors = [];
      if (!this.$v.cliente.ciudad.$dirty) return errors;
      !this.$v.cliente.ciudad.required && errors.push("");
      !this.$v.cliente.ciudad.municipioValida && errors.push("");
      return errors;
    },
    estado_Errors() {
      const errors = [];
      if (!this.$v.cliente.estado.$dirty) return errors;
      !this.$v.cliente.estado.required && errors.push("");
      !this.$v.cliente.estado.estadoValida && errors.push("");
      return errors;
    },
    cp_Errors() {
      const errors = [];
      if (!this.$v.cliente.cp.$dirty) return errors;
      !this.$v.cliente.cp.required && errors.push("");
      !this.$v.cliente.cp.codigoPostalValida && errors.push("");
      return errors;
    },
    razonSocial_Errors() {
      const errors = [];
      if (!this.$v.cliente.razonSocial.$dirty) return errors;
      !this.$v.cliente.razonSocial.razonSValida && errors.push("");
      return errors;
    },
    email_Errors() {
      const errors = [];
      if (!this.$v.cliente.email.$dirty) return errors;
      !this.$v.cliente.email.emailValida && errors.push("");
      return errors;
    },
    telefono_Errors() {
      const errors = [];
      if (!this.$v.cliente.telefono.$dirty) return errors;
      !this.$v.cliente.telefono.required && errors.push("");
      !this.$v.cliente.telefono.telefonoValida && errors.push("");
      return errors;
    },
    pais_Errors() {
      const errors = [];
      if (!this.$v.cliente.pais.$dirty) return errors;
      !this.$v.cliente.pais.required && errors.push("");
      !this.$v.cliente.pais.paisValida && errors.push("");
      return errors;
    }
  },
  watch: {
    async datoQueLimpiaDatosAlCambiar() {
      await this.limpiarDatosCliente();
    },
    datosTitularCuenta() {
      this.nombreDelTitularDelEnvio = this.datosTitularCuenta;
      this.actualizaCliente();
    },
    datosRemitente() {
      if (this.datosRemitente.DIRECCION.length >= 1) {
        const direccion = Array.from(JSON.parse(this.datosRemitente.DIRECCION));
        const colonia = Array.from(JSON.parse(this.datosRemitente.COLONIA));
        const ciudad = Array.from(JSON.parse(this.datosRemitente.MUNICIPIO));
        const estado = Array.from(JSON.parse(this.datosRemitente.ESTADO));
        const cp = Array.from(JSON.parse(this.datosRemitente.CODIGO_POSTAL));
        this.cliente.direccion = direccion[this.datosRemitente.indice];
        this.cliente.colonia = colonia[this.datosRemitente.indice];
        this.cliente.ciudad = ciudad[this.datosRemitente.indice];
        this.cliente.estado = estado[this.datosRemitente.indice];
        this.cliente.cp = cp[this.datosRemitente.indice];
      } else {
        this.cliente.direccion = "";
        this.cliente.colonia = "";
        this.cliente.ciudad = "";
        this.cliente.estado = "";
        this.cliente.pais = "";
        this.cliente.cp = "";
      }
      this.cliente.nombre = this.datosRemitente.NOMBRE_COMPLETO;
      if (this.datosRemitente.ID) {
        this.cliente.id = this.datosRemitente.ID;
        this.deshabilitarCampos = true;
      } else {
        this.deshabilitarCampos = false;
      }
      this.cliente.razonSocial = this.datosRemitente.RAZON_SOCIAL;
      this.cliente.rfc = this.datosRemitente.TAXID;

      this.cliente.tarifaClientePublicoGeneral = this.datosRemitente.TARIFA_GENERAL;
      this.cliente.tarifaClienteEspecifica = this.datosRemitente.TARIFA_CLIENTE;

      this.cliente.email = this.datosRemitente.EMAIL;
      this.cliente.telefono = this.datosRemitente.TELEFONO;
      this.cliente.alias = this.datosRemitente.ALIAS;
      this.cliente.tarifa_seguro = this.datosRemitente.TARIFA_SEGURO;
      this.cliente.idTarifaRemitente = this.datosRemitente.TARIFA_CLIENTE.ID;
      this.actualizaCliente();
    },
    datosDestinatario() {
      if (this.datosDestinatario.DIRECCION.length >= 1) {
        const direccion = Array.from(JSON.parse(this.datosDestinatario.DIRECCION));
        const colonia = Array.from(JSON.parse(this.datosDestinatario.COLONIA));
        const ciudad = Array.from(JSON.parse(this.datosDestinatario.MUNICIPIO));
        const estado = Array.from(JSON.parse(this.datosDestinatario.ESTADO));
        const cp = Array.from(JSON.parse(this.datosDestinatario.CODIGO_POSTAL));
        const pais = Array.from(JSON.parse(this.datosDestinatario.PAIS));

        this.cliente.direccion = direccion[this.datosDestinatario.indice];
        this.cliente.colonia = colonia[this.datosDestinatario.indice];
        this.cliente.ciudad = ciudad[this.datosDestinatario.indice];
        this.cliente.estado = estado[this.datosDestinatario.indice];
        this.cliente.pais = pais[this.datosDestinatario.indice];
        this.cliente.cp = cp[this.datosDestinatario.indice];
      } else {
        this.cliente.direccion = "";
        this.cliente.colonia = "";
        this.cliente.ciudad = "";
        this.cliente.estado = "";
        this.cliente.pais = "";
        this.cliente.cp = "";
      }
      this.cliente.nombre = this.datosDestinatario.NOMBRE_COMPLETO;
      if (this.datosDestinatario.ID) {
        this.cliente.id = this.datosDestinatario.ID;
        this.deshabilitarCampos = true;
      } else {
        this.deshabilitarCampos = false;
      }

      this.cliente.razonSocial = this.datosDestinatario.RAZON_SOCIAL;
      this.cliente.rfc = this.datosDestinatario.TAXID;

      this.cliente.email = this.datosDestinatario.EMAIL;
      this.cliente.telefono = this.datosDestinatario.TELEFONO;
      this.cliente.alias = this.datosDestinatario.ALIAS;
      this.actualizaCliente();
    }
  },
  async mounted() {
    this.actualizaCliente();
    if (this.listaPaises.length < 50) {
      await this.getListaPaises();
    }
  },
  async beforeDestroy() {
    await this.limpiarDatosCliente();
  },
  methods: {
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy"]),
    ...mapActions("enviosRemitentes", [
      "chargeRemitente",
      "destroyRemitente",
      "chargeNombreTitularEnvio"
    ]),
    ...mapActions("enviosDestinatarios", ["chargeDestinatario", "destroyDestinatario"]),
    ...mapActions("sepomex", ["getDatosConCodigoPostal", "getListaPaises"]),
    ...mapActions("remitentesRegistro", ["insertRemitentes", "updateTarifasRemitentes"]),
    ...mapActions("destinatarioRegistro", ["insertDestinatarios"]),
    ...mapActions("enviosInfoEnvio", ["destroyStoreInfoEnvio"]),
    buscarDireccionEnGoogleMaps() {
      let cadenaBusqueda = `${this.cliente.direccion} ${this.cliente.colonia} ${this.cliente.ciudad} ${this.cliente.estado} ${this.cliente.pais} ${this.cliente.cp}`;
      console.log("buscar direccion maps", cadenaBusqueda);
      window.open("https://www.google.com/maps/search/" + cadenaBusqueda, "_blank");
    },
    async actualizaTarifaRemitente() {
      await this.updateTarifasRemitentes({
        idRemitente: this.cliente.id,
        IdTarifa: this.cliente.idTarifaRemitente,
        tarifaSeguro: 0
      });
      //console.log(this.cliente.idTarifaRemitente);
    },
    quitarAcentos(cadena) {
      const acentos = {
        á: "a",
        å: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U"
      };
      return cadena
        .split("")
        .map(letra => acentos[letra] || letra)
        .join("")
        .toString();
    },
    async insertaNuevoCliente() {
      this.$v.cliente.$touch();
      // si ya hay un id asignado nos saltamos la insercion
      if (this.$v.$invalid) {
        this.mensajeSnackbarInfo = "ALERTA: Revise nuevamente la información insertada";
        this.colorModalInfo = "red darken-1";
        this.snackbarInfo = true;
        return;
      } else {
        if (this.cliente.id == "" || this.cliente.id == null) {
          if (this.tipoDeCliente == "Remitente") {
            if (this.cliente.envioOcurre == true) {
              //si se inserta remitente sin direccion se usa este metodo
              const respR = await this.insertRemitentes({
                Nombre_Completo: this.cliente.nombre,
                Razon_Social: this.cliente.razonSocial,
                Email: this.cliente.email,
                Telefono: this.cliente.telefono,
                Tarifa: this.cliente.idTarifaRemitente,
                Sucursal: this.logedInUserInfo.sucursal,
                Tarifa_Seguro: "0",
                TaxId: this.cliente.rfc
              });
              if (respR[0]) {
                this.cliente.id = respR[1];
                this.cliente.tarifaClientePublicoGeneral = respR[2][1];
                this.cliente.tarifaClienteEspecifica = respR[2][0];
                this.deshabilitarCampos = true;
                this.colorModalInfo = "blue darken-1";
                this.mensajeSnackbarInfo = "Remitente insertado con éxito";
                this.snackbarInfo = true;
                // console.log(respR[1]);
              } else {
                this.colorModalInfo = "red darken-1";
                this.mensajeSnackbarInfo = "ALERTA: Hubo un error en la inserción del remitente";
                this.snackbarInfo = true;
              }
            } else {
              // si se inserta destinatario con direccion se usa este metodo
              const respR = await this.insertRemitentes({
                Nombre_Completo: this.cliente.nombre,
                Razon_Social: this.cliente.razonSocial,
                Direccion: [
                  {
                    estado: this.cliente.estado,
                    municipio: this.cliente.ciudad,
                    codigopostal: this.cliente.cp,
                    colonia: this.cliente.colonia,
                    direccion: this.cliente.direccion
                  }
                ],
                Email: this.cliente.email,
                Telefono: this.cliente.telefono,
                Tarifa: this.cliente.idTarifaRemitente,
                Sucursal: this.logedInUserInfo.sucursal,
                Tarifa_Seguro: "0",
                TaxId: this.cliente.rfc
              });
              if (respR[0]) {
                console.info("this is the answer", respR[1]);
                this.cliente.id = respR[1];
                this.cliente.tarifaClientePublicoGeneral = respR[2][1];
                this.cliente.tarifaClienteEspecifica = respR[2][0];
                this.deshabilitarCampos = true;
                this.colorModalInfo = "blue darken-1";
                this.mensajeSnackbarInfo = "Remitente insertado con éxito";
                this.snackbarInfo = true;
              } else {
                this.colorModalInfo = "red darken-1";
                this.mensajeSnackbarInfo = "ALERTA: Hubo un error en la inserción del remitente";
                this.snackbarInfo = true;
              }
            }
          } else {
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            // DESTINATARIO
            if (this.cliente.envioOcurre == true) {
              //si se inserta destinatario sin direccion se usa este metodo
              const respD = await this.insertDestinatarios({
                Nombre_Completo: this.cliente.nombre,
                Razon_Social: this.cliente.razonSocial,
                Email: this.cliente.email,
                Telefono: this.cliente.telefono,
                Sucursal: this.logedInUserInfo.sucursal,
                TaxId: this.cliente.rfc
              });
              if (respD[0]) {
                this.cliente.id = respD[1];
                this.deshabilitarCampos = true;
                this.colorModalInfo = "blue darken-1";
                this.mensajeSnackbarInfo = "Destinatario insertado con éxito";
                this.snackbarInfo = true;
              } else {
                this.colorModalInfo = "red darken-1";
                this.mensajeSnackbarInfo = "ALERTA: Hubo un error en la inserción del destinatario";
                this.snackbarInfo = true;
              }
            } else {
              //si se inserta destinatario con direcccion, se usa este metodo
              const respD = await this.insertDestinatarios({
                Nombre_Completo: this.cliente.nombre,
                Razon_Social: this.cliente.razonSocial,
                Direccion: [
                  {
                    pais: this.cliente.pais,
                    estado: this.cliente.estado,
                    municipio: this.cliente.ciudad,
                    codigopostal: this.cliente.cp,
                    colonia: this.cliente.colonia,
                    direccion: this.cliente.direccion
                  }
                ],
                Email: this.cliente.email,
                Telefono: this.cliente.telefono,
                Sucursal: this.logedInUserInfo.sucursal,
                TaxId: this.cliente.rfc
              });
              if (respD[0]) {
                this.cliente.id = respD[1];
                this.deshabilitarCampos = true;
                this.colorModalInfo = "blue darken-1";
                this.mensajeSnackbarInfo = "Destinatario insertado con éxito";
                this.snackbarInfo = true;
              } else {
                this.colorModalInfo = "red darken-1";
                this.mensajeSnackbarInfo = "ALERTA: Hubo un error en la inserción del destinatario";
                this.snackbarInfo = true;
              }
            }
          }
        }
      }

      // actualizamos cliente despues de insertar para que se pueda usar para el envio

      this.actualizaCliente();
    },
    async limpiarDatosCliente() {
      console.info("limpieza datos cliente");
      this.$v.$reset();
      if (this.tipoDeCliente == "Remitente") {
        await this.destroyRemitente();
        await this.destroyRemitente();
      } else {
        await this.destroyDestinatario();
        await this.destroyDestinatario();
      }
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreInfoEnvio();
      this.nombreDelTitularDelEnvio = "";
      this.cliente = {
        envioOcurre: false,
        alias: "",
        id: "",
        nombre: "",
        razonSocial: "",
        direccion: "",
        colonia: "",
        ciudad: "",
        estado: "",
        cp: "",
        pais: "",
        telefono: "",
        email: "",
        idTarifaRemitente: 1,
        tarifaClienteEspecifica: "",
        tarifaClientePublicoGeneral: "",
        rfc: ""
      };

      this.deshabilitarCampos = false;
      this.actualizaCliente();
    },
    async consultaCodigoPostal(codigo) {
      this.codigosPostalesEncontrados = [];
      const res = await this.getDatosConCodigoPostal(codigo);
      if (res[0] && res[1].length > 0) {
        if (res[1].length > 1) {
          this.mostrarComboxColonias = true;
          res[1].forEach(element => this.codigosPostalesEncontrados.push(element.ASENTAMIENTO));
        } else {
          this.mostrarComboxColonias = false;
        }
        this.cliente.ciudad = res[1][0].MUNICIPIO;
        this.cliente.colonia = res[1][0].ASENTAMIENTO;
        this.cliente.estado = res[1][0].ESTADO;
        this.cliente.pais = res[1][0].PAIS;
      }
    },
    actualizaClienteCodigoPostal: _.debounce(async function() {
      if (
        this.cliente.cp.length === 5 &&
        (this.cliente.pais == "" ||
          this.cliente.pais == null ||
          this.quitarAcentos(this.cliente.pais + "").toLowerCase() == "mexico")
      ) {
        this.consultaCodigoPostal(this.cliente.cp);
      }
      this.actualizaCliente();
    }, 400),
    actualizaCliente: _.debounce(async function() {
      if (this.tipoDeCliente == "Remitente") {
        if (this.cliente.envioOcurre) {
          this.cliente.direccion = this.sucursalInfo.DIRECCION;
          this.cliente.estado = this.sucursalInfo.ESTADO;
          this.cliente.cp = this.sucursalInfo.CODIGO_POSTAL;
          this.cliente.colonia = this.sucursalInfo.COLONIA;
          this.cliente.ciudad = this.sucursalInfo.MUNICIPIO;
          this.deshabilitarCamposOcurre = true;
        } else {
          this.deshabilitarCamposOcurre = false;
        }
        await this.chargeNombreTitularEnvio(this.nombreDelTitularDelEnvio);
        await this.chargeRemitente(this.cliente);
      } else {
        // si el pais del cliente es un objeto
        // asignamos el nombre del pais a la variable del paisdelcliente
        if (this.cliente.pais) {
          if (this.cliente.pais.NOMBRE) {
            this.cliente.pais = this.cliente.pais.NOMBRE;
          }
        }
        await this.chargeDestinatario(this.cliente);
      }
    }, 400),
    abreModalClientes() {
      this.$emit("abreModalClientes");
    },
    abreModalClientesParaInsertarTitular() {
      this.$emit("abreModalClientesParaInsertarTitular");
    },
    abreModalCajas(){
      this.$emit("abreModalCajas");
    }
  }
};
</script>

<style lang="css">
.mtll {
  margin-bottom: -15px;
}
</style>
